var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "productAsideReviews",
      style: { width: "100%" },
      attrs: {
        "aria-label": "Click to read all " + _vm.onText,
        title: "Click to read all " + _vm.onText,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.handleScroll()
        },
      },
    },
    [
      _vm.rating === 4
        ? _c(
            "div",
            [_c("Star4"), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.onText))])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.rating === 4.5
        ? _c(
            "div",
            [
              _c("Star4half"),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.onText))]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.rating === 5
        ? _c(
            "div",
            [_c("Star5"), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.onText))])],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }